import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { XMarkIcon } from "@heroicons/react/24/outline";

interface QuoterLegalInfoProps {
  show: boolean;
  onClose: () => void;
}

export const QuoterLegalInfo = ({ show, onClose }: QuoterLegalInfoProps) => {
  const [t] = useTranslation("global");

  return (
    <>
      {show && (
        <div
          className="w-full h-full z-[100] fixed top-0 bg-black/30"
          onClick={onClose}
        />
      )}
      <div
        className={classNames(
          "w-full flex flex-col items-center justify-center z-[120] fixed bottom-0 px-6 rounded-t-2xl bg-white shadow-xl shadow-gray-400 transition-all",
          "lg:rounded-xl lg:max-w-[44rem] lg:shadow-none lg:transition-none lg:h-fit", // Desktop styles
          {
            "max-h-0 py-0": !show,
            "max-h-[80vh] lg:top-[50%] lg:left-[50%] lg:-translate-x-[50%] lg:-translate-y-[50%] lg:min-h-52 lg:max-h-none pt-6 pb-14 lg:p-6 lg:pb-10":
              show,
          }
        )}
      >
        <div className="w-full h-full flex flex-col gap-4 overflow-hidden">
          <div className="w-full flex justify-end cursor-pointer">
            <XMarkIcon className="w-5 h-5" onClick={onClose} />
          </div>
          <div className="overflow-y-auto">
            <p
              className="w-full text-xs md:text-sm text-gray-500 text-justify inner-span-bolden"
              dangerouslySetInnerHTML={{
                __html: t("Quoter.DisclaimerExtended"),
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
